









import {
  Component, mapState, Watch, mixins,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import CampaignTab from '@/views/Programs/Campaign/CampaignTab.vue';
import CampaignGroupTab from '@/views/Programs/Campaign/CampaignGroupTab.vue';

class CampaignState {
    activeTab: string = 'campaign'
}

@Component({
  /**
   * Imported components
   * */
  components: { CampaignTab, CampaignGroupTab },
  /**
   * Stores values
   * */
  computed: {
    ...mapState({
      loading: (state: any) => state.campaign.campaignStore.loading,
    }),
  },
  /**
   * Component properties
   * */
  props: {},
})
export default class Campaign extends mixins(SamclickMixins) {
  /**
   * Local state
   * */
    state = new CampaignState();

  /**
   * Watchers
   * */
  @Watch('componentState.var')
    sampleWatcher(newVal: string, oldVal: string) {

    }

  /**
   * Methods
   * */
  actionMethod() {

  }


  /**
   * Computed
   * */
  get computedVal() {
    return {};
  }

  /**
   * Lifecycle hooks
   * */
  created() {}

  mounted() {

  }

  beforeUpdate() {}
}
